"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOperand = void 0;
var FilterOperand;
(function (FilterOperand) {
    FilterOperand["In"] = "IN";
    FilterOperand["NotIn"] = "NOT_IN";
    FilterOperand["GreaterThan"] = "GREATER_THAN";
    FilterOperand["GreaterThanOrEqualsTo"] = "GREAT_THAN_EQUALS_TO";
    FilterOperand["LessThan"] = "LESS_THAN";
    FilterOperand["LessThanOrEqualsTo"] = "LESS_THAN_EQUALS_TO";
    FilterOperand["Between"] = "BETWEEN";
    FilterOperand["Equals"] = "EQUALS";
    FilterOperand["NotEquals"] = "NOT_EQUALS";
})(FilterOperand = exports.FilterOperand || (exports.FilterOperand = {}));
